import React from "react";

class ContactPage extends React.Component {
  constructor(props) {
    super(props);
  }

  renderNavBar = () => {
    return (
      <div className="navbar-section">
        <div className="navbar-content">
          <a href="/" style={{ textDecoration: "none" }}>
            <div className="logo-container">
              <img
                className="logo-img"
                src={require("../../images/trybe-logo-white.svg")}
              />
              <div className="logo-text">TRYBE</div>
            </div>
          </a>
        </div>
      </div>
    );
  };

  render() {
    return (
      <div className="contact-page-container">
        {this.renderNavBar()}
        <div className="main-container">
          <div className="contact-page-title">Contact Us</div>
          <img
            src={require("../../images/email-icon.png")}
            className="email-icon"
          />
          <div className="contact-page-subtitle">
            Have suggestions or need help?
          </div>
          <div className="contact-page-subtitle">Email us!</div>
          <div className="email-row">
            <div className="email-text">Support questions:</div>
            <a className="email-link" href="mailto:support@trybe.do">
              support@trybe.do
            </a>
          </div>
          <div className="email-row">
            <div className="email-text">Suggestions:</div>
            <a className="email-link" href="mailto:support@trybe.do">
              hello@trybe.do
            </a>
          </div>
        </div>
      </div>
    );
  }
}

module.exports = ContactPage;



// WEBPACK FOOTER //
// ./src/components/pages/ContactPage.js